// @file Entrypoint for home page
import { captureException } from 'bits/error_tracker'
import { setupVueApp } from 'bits/vue'
import HomeApp from 'vuecomponents/home_app.vue'
import { storeOptions } from 'vuexstore/home_store'

setupVueApp({
  el: '#app',
  rootComponent: HomeApp,
  storeOptions,
  initializeStore(store) {
    store.dispatch('initializeState').catch(captureException)
  },
}).catch(captureException)
